import { cn } from '@/lib/utils'

type Props = {
  text: string
  textColor?: string
  backgroundColor?: string
  className?: string
}

export const ProductVariantFlag = ({
  text,
  textColor = 'hsl(var(--primary))',
  backgroundColor = '#A9BC62',
  className,
}: Props) => (
  <div
    className={cn(
      'z-10 flex h-[2.91338rem] w-[3.3125rem] items-center justify-center rounded-b-[3rem] rounded-t-[0.125rem] px-3 sm:h-[4.5625rem] sm:w-[5.1875rem]',
      className,
    )}
    style={{ backgroundColor }}
  >
    <p
      className="text-center text-[0.5rem] font-semibold sm:text-sm"
      style={{ color: textColor }}
    >
      {text}
    </p>
  </div>
)
